<template>
  <v-container fluid>    
    <v-row justify="center">
      <v-col cols="auto">
        <v-select
          :items="salespersons"
          item-value="SMAN_DOCNO"
          item-text="SMAN_DESC"
          label="Sales-persons"
          solo
          v-model="selectedsalesman"
          @change="getSummary"
          clearable
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          class="ml-2 mt-1"
          fab
          dark
          small
          color="primary"
          @click="getSummary"
        >
          <v-icon dark>
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn 
          class="ml-2 mt-1"
          fab
          dark
          small
          color="primary"
          @click="showDateFilter"        
        >
          <v-icon>
            mdi-calendar-range
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="datefiltervisible">    
      <v-col
        cols="6"
        sm="6"
        md="4"
      >
        <v-dialog
          ref="dialog1"
          v-model="modal1"
          :return-value.sync="fromDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fromDate"
              label="To Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fromDate"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="modal1 = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialog1.save(fromDate)"
            >
              OK
            </v-btn>       
          </v-date-picker>
        </v-dialog>
      </v-col> 
      <v-col
        cols="6"
        sm="6"
        md="4"
      >
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="toDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="toDate"
              label="To Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="toDate"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="modal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialog.save(toDate)"
            >
              OK
            </v-btn>
            

          </v-date-picker>
        </v-dialog>
      </v-col>   
    </v-row>    
    <v-row>
        <v-col
          v-for="month in matches" 
          :key="month.MONTHLY_SALES"
          cols="12" sm="6" md="4" >
        <Summarycard       
          :ActProfit="month.ActProfit"
          :CustInvoiced ="month.CustInvoiced"
          :DocMonth="month.DocMonth"
          :DocYear="month.DocYear"
          :MTDTarget="month.MTDTarget"
          :MonthName="month.MonthName"
          :Profit="month.Profit"
          :ProfitRatio="month.ProfitRatio"
          :Sale="month.Sale"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Summarycard from "@/components/Summarycard";


export default {
  components: {
    Summarycard,
  },

  data() {
    return {
      items: [1, 2, 3, 4, 5],
      selectedsalesman: "",
      datefiltervisible:false,
      custfilterdialog: false,      
      modal: false,
      modal1: false, 
      custsearch: null,
      fromDate:new Date(new Date().getFullYear(),new Date().getMonth(), 2).toISOString().substr(0, 10),
      toDate:new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    };
  },

  computed: {
    usersperson() {
      if (this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO) {
        return this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO;
      } else {
        return "";
      }
    },
    salespersons() {
      return this.$store.getters.salespersons;
    },
    salesperson() {
      return this.$store.getters.salesperson;
    },
    sman() {
      if (this.selectedsalesman) {
        return this.selectedsalesman;
      } else {
        return this.usersperson;
      }
    },
    summarydata() {
      return this.$store.getters.summarydata;
    },

    BLOCKED_CUSTOMERS() {
      return this.summarydata.BLOCKED_CUSTOMERS;
    },
    ALL_CUSTOMERS() {
      if (this.summarydata.ALL_CUSTOMERS > 0) {
        return this.summarydata.ALL_CUSTOMERS.toFixed(0);
      } else {
        return 0;
      }
    },
    OPEN_CUSTOMERS() {
      if (this.summarydata.ALL_CUSTOMERS > 0) {
        return (this.ALL_CUSTOMERS - this.BLOCKED_CUSTOMERS).toFixed(0);
      } else {
        return 0;
      }
    },
    OPEN_PERCENTAGE() {
      return (this.OPEN_CUSTOMERS / this.ALL_CUSTOMERS) * 100;
    },
    SALE_THIS_MONTH() {
      if (this.summarydata.SALE_THIS_MONTH > 0) {
        return this.summarydata.SALE_THIS_MONTH.toFixed(0);
      } else {
        return 0;
      }
    },
    AVG_SALE() {
      if (this.summarydata.AVG_SALE > 0) {
        return this.summarydata.AVG_SALE.toFixed(0);
      } else {
        return 0;
      }
    },
    PROFIT_THIS_MONTH() {
      if (this.summarydata.PROFIT_THIS_MONTH > 0) {
        return this.summarydata.PROFIT_THIS_MONTH.toFixed(0);
      } else {
        return 0;
      }
    },
    salevsavgsale() {
      return (this.SALE_THIS_MONTH / this.AVG_SALE) * 100;
    },
    GP_THIS_MONTH() {
      return (this.PROFIT_THIS_MONTH / this.SALE_THIS_MONTH) * 100;
    },
    CUSTOUTS_OUTSTANDING() {
      if (this.summarydata.CUSTOUTS_OUTSTANDING > 0) {
        return this.summarydata.CUSTOUTS_OUTSTANDING.toFixed(0);
      } else {
        return 0;
      }
    },
    CUSTOUTS_OUTSTANDING_ABOVE45() {
      if (this.summarydata.CUSTOUTS_OUTSTANDING_ABOVE45 > 0) {
        return this.summarydata.CUSTOUTS_OUTSTANDING_ABOVE45.toFixed(0);
      } else {
        return 0;
      }
    },
    ABV_45_PC() {
      return (
        100 -
        (this.CUSTOUTS_OUTSTANDING_ABOVE45 / this.CUSTOUTS_OUTSTANDING) * 100
      );
    },
    CUSTOUTS_PDC() {
      if (this.summarydata.CUSTOUTS_PDC > 0) {
        return this.summarydata.CUSTOUTS_PDC.toFixed(0);
      } else {
        return 0;
      }
    },
    DEBTOR_RATIO() {
      return (
        (this.CUSTOUTS_PDC + this.CUSTOUTS_OUTSTANDING) /
        this.SALE_THIS_MONTH
      ).toFixed(0);
    },
    TREND_MONTHS() {
      if (this.summarydata.MONTHLY_SALE) {
        return this.summarydata.MONTHLY_SALE.map(
          (a) => a.MonthName.substr(0, 3)
          /*+ "- \n"
        + (a.Sale / 1000000).toFixed(1)
        + " M"*/
        );
      } else {
        return [];
      }
    },
    SALE_TREND_VALUES() {
      if (this.summarydata.MONTHLY_SALE) {
        return this.summarydata.MONTHLY_SALE.map((a) => a.Sale);
      } else {
        return [];
      }
    },
    CUS_TREND_VALUES() {
      if (this.summarydata.MONTHLY_SALE) {
        return this.summarydata.MONTHLY_SALE.map((a) => a.CustInvoiced);
      } else {
        return [];
      }
    },   
    MONTHLY_SALES() {
      if (this.summarydata.MONTHLY_SALE) {
        let monthly = this.summarydata.MONTHLY_SALE;
        return monthly.reverse();
        //return //this.summarydata.MONTHLY_SALE.reverse();//.map((a) => a.CustInvoiced);
      } else {
        return [];
      }
    },
    matches() {
      if (this.custsearch == null) {
        return this.MONTHLY_SALES;
      } else {
        return this.MONTHLY_SALES.filter((month) =>
          month.MonthName.toLowerCase().includes(
            this.custsearch.toLowerCase()
          )
        );
      }
    },
  },

  methods: {
    setSalesPerson() {
      this.$store.dispatch("getSalesPerson", { smandocno: this.sman });
    },
    getSummary() {
      this.setSalesPerson();
      this.$store.dispatch("getSummaryData",{ 
                            smandocno: this.salesperson , 
                            fromDate: this.fromDate ,
                            toDate: this.toDate ,
                            });
    },
    showDateFilter() {
      this.datefiltervisible = !this.datefiltervisible;
    },
  },

  mounted() {
    this.$store.dispatch("getLoading", true);

    this.getSummary();
    
    this.$store.dispatch("getLoading", false);
  },
};
</script>
